import { loginUser } from "../services/authService";
import {
  getUserLabTests,
  getUserImagingTests,
  getUserMicrobiologyTests,
  getUserPathoanatomyTests,
} from "../services/userService";

export const api = {
  loginUser,
  getUserLabTests,
  getUserImagingTests,
  getUserMicrobiologyTests,
  getUserPathoanatomyTests,
};
